import { Gen1 } from './Gen1';
import { Gen2 } from './Gen2';
import { Gen3 } from './Gen3';
import { Gen4 } from './Gen4';
import { BLE } from './BLE';
import { Android } from './Android';
import { Prototypes } from './Prototypes';
import { xmod } from './xmod';
import { vtac } from './vtac';
import { Loqed } from './Loqed';
import { Virtual } from './Virtual';
import { Zendure } from './Zendure';
import { EcoFlow } from './EcoFlow';
import { Camera } from './Camera';

export const Shelly = {
	...Gen1,
	...Gen2,
	...Gen3,
	...Gen4,
	...BLE,
	...EcoFlow,
	...Android,
	...Prototypes,
	...xmod,
	...vtac,
	...Loqed,
	...Virtual,
	...Zendure,
	...Camera,
};
